export const odluka_prigodna_nagrada_bozicnica_uskrsnica_regres = {
    templateId: 38,
    category: 4,
    templateTitle: 'Odluka - prigodna nagrada - božićnica,uskrsnica,regres',
    templateDescription: `<p>Poslodavac može (odnosno mora, ukoliko ga na to obvezuje pravilnik o radu, kolektivni ugovor i sl.) neoporezivo isplatiti radniku božićnica, uskrsnica i regres, pri čemu je navedena isplata neoporeziva do iznosa od najviše ukupno 5.000,00 kn godišnje.</p>`,
    description: `
    <h5><strong>OPIS DOKUMENTA</strong></h5>
    <p>Pravilnikom o porezu na dohodak propisani su primici koji se ne smatraju plaćom i na koje se ne plaća porez na dohodak - neoporezive isplate.</p>
    <p>U navedene primitke ubrajaju se i prigodne nagrade: božićnica, uskrsnica i regres.</p>
    <p>Božićnica, uskrsnica i regres su prigodne nagrade koje se smatraju materijalnim pravima radnika, a koja nisu izravno propisana Zakonom o radu, nego se po potrebi uređuju kolektivnim ugovorom, pravilnikom o radu ili ugovorom o radu.</p>
    <p>Međutim, ukoliko navedena prava nisu propisana pravilnikom o radu ili kolektivnim ugovorom odnosno ako nisu određena ugovorom o radu, onda poslodavac samostalno odlučuje hoće li navedena prava omogućiti radniku i u kojem opsegu (u cijelosti ili djelomično).</p>
    <p>Također, prigodna nagrada je za poslodavca porezno priznati trošak s aspekta utvrđivanja osnovice poreza na dobit, no samo ako navedene prigodne nagrade ne prelaze ukupan iznos od 5.000,00 kn godišnje po radniku.</p>
    <p>I radnik s nepunim radnim vremenom može ostvariti puni iznos neoprezive isplate prigodne nagrade, bez obzira na sate rada, ako je tako ugovoreno.</p>
    <p>Važno je naglasiti da radnik koji ima pravo na isplatu regresa će to pravo moći ostvariti u slučaju da zaista i koristi godišnji odmor.</p>
    <p>Ukoliko se prigodna nagrada (regres, uskrsnica, božićnica i sl.) isplaćuje radniku koji radi istovremeno kod dva ili više poslodavaca u poreznom razdoblju za koje se prigodna nagrada isplaćuje i/ili je tijekom poreznog razdoblja imao zasnovan radni odnos kod dva ili više poslodavaca, ali ne istodobno, radnik je obvezan prije isplate prigodne nagrade svakom poslodavcu podnijeti pisanu izjavu u kojoj će navesti je li kod drugog i/ili bivšeg poslodavca ostvario isplatu prigodne nagrade za to porezno razdoblje, u kojem iznosu i je li po toj osnovi obračunan i uplaćen predujam poreza na dohodak. U slučaju da je prigodna nagrada već isplaćena tijekom godine kod drugog poslodavca, neoporezivo se može isplatiti samo razlika do 5.000,00 kuna.</p>
    <p>Prigodne nagrade su izuzete od ovrhe (do propisanih iznosa do kojih se ne smatraju oporezivim primitkom) te se u slučaju blokade računa radnika uplaćuju  na račun radnika koji je zaštićen od ovrhe na novčanim sredstvima (tzv. zaštićeni račun).
    <p><strong>SVRHA DOKUMENTA</strong></p>
    <p>Svrha božićnice i uskrsnice je prihodno nagrađivanje tijekom božićnih i uskrsnih blagdana.</p>
    <p>Svrha regresa je podmirivanje troškova odmora koji radniku nastaju kao povećani troškovi odmora, putovanja i sl., i to upravo u razdoblju korištenja godišnjeg odmora.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak, Ovršni zakon.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o porezu na dohodak i Pravilnika o porezu na dohodak,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],
    // <p>Inače je neoporezive isplate do dopuštenog iznosa na koji se ne plaća porez moguće sukladno Pravilniku o porezu na dohodak isplatiti u gotovu novcu, no u ovom slučaju, to pravo je ograničeno obvezom provedbe ovrhe prema Ovršnom zakonu, stoga se treba pridržavati važećih uputa nadležnih tijela.</p>
    // <p>Prema Uputi Ministarstva financija, KLASA 400/06/16-01/330 Ur.br. 513- 05 -02- 17-8 od 4. srpnja, 2017. godine poslodavac može prigodnu nagradu (božićnica, uskrsnica, regres i sl.) isplatiti radniku u gotovini, do najvišeg dopuštenog neoporezivog iznosa ukoliko radnik izričito zahtijeva takav način isplate, te ukoliko je ispunjen jedan ili oba dolje navedena uvjeta:</p>
    // <li> u slučaju da je određena ovrha na tražbini po računu radnika na temelju koje poslodavac ne provodi ovrhu, niti je vezan rješenjem o ovrsi te nije dužan plijeniti ovršenikova primanja (ovrhu provodi FINA),</li>
    // <li> u slučaju do ovrhu provodi poslodavac na temelju rješenja o ovrsi kojim je ovrha određena samo (isključivo) na plaći te se ovrha provodi samo na plaći, a ne i na drugom stalnom novčanom primanju (navedeno podatak je vidljiv u rješenju o ovrsi).</li>
    // <br>
    // <p>Ukoliko postoje gore navedeni uvjeti za isplatu neoporezive isplate radniku u gotovini, poslodavac može isplatiti neoporezivu isplatu u gotovini samo do neoporezivog iznosa (u slučaju prigodne nagrade, do 3.000 kuna godišnje)</p>
    // <p><strong>S druge strane, ukoliko poslodavac provodi:</strong></p>
    // <li> ovrhu općenito na imovini radnika kao ovršenika na temelju rješenja o ovrsi donesenog od strane javnog bilježnika, ili</li>
    // <li> ovrhu na plaći i drugim stalnim novčanim primanjima, što podrazumijeva i plaću te ostale neoprezive isplate, ili</li>
    // <li> postupa u skladu s privatnom ispravom potvrđenom po javnom bilježniku koja ima pravni učinak pravomoćnog rješenja o ovrsi, a kojom je dužnik dao suglasnost za zapljenu plaće odnosno drugog stalnog novčanog primanja (osim u dijelu u kojem je to primanje izuzeto od ovrhe),</p>
    // <p>dužan je prigodnu nagradu (božićnicu, uskrsnicu, regres i sl.) isplatiti na račun kojeg je ovrhovoditelj naveo u rješenju o ovrsi tj. poslodavcu je u tom slučaju zabranjeno radniku isplatiti regres za korištenje godišnjeg odmora u gotovini.</p>
    // <p>Slično se navodi i u mišljenju Ministarstvo pravosuđa, Klasa: 740-11/16-01/359, Urbroj: 514-04-01-02-16-02 od 16. prosinca 2016. godine te Mišljenju Porezne uprave, klasa: 410-01/14-01/45, Urbroj: 513-07-21-01/14-03 od 30. siječnja 2015. godine.</p>
   

    headline: 'donosi sljedeću',
    title: ' ODLUKU ',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovom Odlukom određuje se isplata prigodne nagrade radnicima povodom božićnih blagdana – božićnica, u vrijednosti'
                                },
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn.'}]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovom Odlukom određuje se isplata prigodne nagrade radnicima povodom uskrsnih blagdana – uskrsnica, u vrijednosti'
                                },
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn.'}]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovom Odlukom određuje se isplata prigodne nagrade radnicima povodom korištenja godišnjeg odmora – regres, u vrijednosti'
                                },
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn.'}]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovom Odlukom određuje se isplata prigodne nagrade  povodom korištenja godišnjeg odmora – regres, radniku'
                                },
                                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                                { type: "text", content: "," },
                                { type: 'text', content: 'iz',},
                                { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                                { type: 'text', content: ',' },
                                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                                { type: "text", content: "," },
                                { type: 'text', content: 'OIB:' },
                                {type: 'input', value: '', required: true},
                                {
                                    type: 'text',
                                    content: ', (u daljnjem tekstu: Radnik)'
                                },

                                {type: 'text', content: 'u vrijednosti'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn.'}]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Prigodna nagrada iz ove Odluke isplaćuje se u roku od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'dana od dana donošenja ove Odluke.'}]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Prigodna nagrada iz ove Odluke isplaćuje se zajedno s isplatom plaće za mjesec'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: ','},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'godine.'}]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Prigodna nagrada iz ove Odluke isplaćuje se najkasnije do'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'godine.'}]
                                
                        }],
                    value: '',
                }
            ]
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: true,
                    choices: [
                        'Prigodnu nagradu iz ove Odluke Poslodavac će isplatiti na tekući račun radnika.',
                        'Prigodnu nagradu iz ove Odluke Poslodavac će isplatiti u gotovini.',
                        'Poslodavac samostalno odlučuje u svakom pojedinom slučaju na koji način će se isplatiti nagrada iz ove Odluke, u gotovini ili na redovan račun radnika.'
                 ],
                 placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                    help: 'Prije odabira načina isplate molimo pažljivo pročitajte tekst gore u kojemu se navodi u kojim slučajevima je dopuštena isplata prigodne nagrade u gotovini.'
                }
            ]
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Ukoliko postoji zakonska mogućnost korištenja neoporezive isplate, pri isplati prigodne nagrade koristiti će se ta porezna mogućnost.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Odluka se primjenjuje s danom donošenja.',
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\nKadrovska služba \r\nObračun plaća \r\n\r\nObavijest o odluci: Oglasna ploča.',
                    help: 'Po želji, slobodno izmijenite/obrišite predložene unose odnosno dopišite istima željene podatke.'
                }
            ]
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/38_odluka_prigodna_nagrada_bozicnica_uskrsnica_regres.ts